import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import NonIntegratedSoftwareAuthorization from './NonIntegratedSoftwareAuthorization';
import Footnote from './../Footnote';

export default class DentalAuthorization extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (
      typeof nextProps.softwares.isRequested === 'boolean' &&
      nextProps.softwares.isRequested !== this.props.softwares.isRequested &&
      nextProps.softwares.isRequested
    ) {
      // Fetch text number
      this.props.getTextNumber();

      // Get Bookings Software Info
      this.props.getBookingSoftware();

      this.props.history.push('/app/setup');
    }
  }

  componentWillUnmount() {
    // Get Bookings Software Info
    this.props.getBookingSoftware();
  }

  render() {
    const { onBackClick } = this.props;

    return (
      <div className="booking-software">
        <p className="booking-software__text">Please provide information about your practice</p>
        <div className="connect-booking-software">
          <div className="connect-booking-software__card">
            <div className="card">
              <div className="card__header">
                {this.props.softwares.brand ?
                <span className="card__header__text">Practice Setup Brand Account</span>
                : <span className="card__header__text">Practice Setup Location Account</span>}
                <NavLink className="connect-booking-software__card__help" to="/app/help">
                  Need help?
                </NavLink>
              </div>
              <div className="card__content" style={{ overflow: 'auto' }}>
                <div className="connect-booking-software__card__content" style={{ justifyContent: 'center' }}>
                  <NonIntegratedSoftwareAuthorization {...this.props} onBackClick={onBackClick} />
                </div>
              </div>
            </div>
          </div>
          <Footnote />
        </div>
      </div>
    );
  }
}

DentalAuthorization.defaultProps = {
  getBookingSoftware: () => {},
  getTextNumber: () => {},
  router: {
    push: () => {},
  },
};

DentalAuthorization.propTypes = {
  getBookingSoftware: PropTypes.func,
  getTextNumber: PropTypes.func,
  onBackClick: PropTypes.func.isRequired,
  softwares: PropTypes.shape({
    selectedSoftware: PropTypes.string,
    isSoftwareSaved: PropTypes.bool,
    isSoftwareSelected: PropTypes.bool,
    isActivated: PropTypes.bool,
    isVerified: PropTypes.bool,
    isRequested: PropTypes.bool,
    isApproved: PropTypes.bool,
    status: PropTypes.shape({
      isSetup: PropTypes.bool,
    }),
  }).isRequired,
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
};
